module.exports = __webpack_public_path__ + "img/mail.f4777d0e.svg";